/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export { ApiError } from './core/ApiError';
export { CancelablePromise, CancelError } from './core/CancelablePromise';
export { OpenAPI } from './core/OpenAPI';
export type { OpenAPIConfig } from './core/OpenAPI';

export { AppointmentsService } from './services/AppointmentsService';
export { AuthenticationService } from './services/AuthenticationService';
export { CaseTypesService } from './services/CaseTypesService';
export { CitiesService } from './services/CitiesService';
export { ClientsService } from './services/ClientsService';
export { CountriesService } from './services/CountriesService';
export { CourtCasesService } from './services/CourtCasesService';
export { CourtsService } from './services/CourtsService';
export { CourtTypesService } from './services/CourtTypesService';
export { DepartmentsService } from './services/DepartmentsService';
export { ExpensesService } from './services/ExpensesService';
export { FormsAndPrecedentsService } from './services/FormsAndPrecedentsService';
export { GeneralSettingsService } from './services/GeneralSettingsService';
export { InvoicesService } from './services/InvoicesService';
export { JudgesService } from './services/JudgesService';
export { StatesService } from './services/StatesService';
